import { Skeleton } from "@workspace/web-ui/components/skeleton";

export const QuickActionCardSkeleton = () => {
  return (
    <article
      className="flex md:flex-row flex-col gap-4 p-4 border border-[#E6E6E6] border-l-[6px] border-l-[#4272DD] rounded-r-[8px] shadow-sm bg-white justify-between items-start w-full animate-pulse"
      data-testid="appointment-card-skeleton"
    >
      <div className="flex flex-col gap-3 w-full">
        <Skeleton className="h-6 w-1/2 mb-2" />
        <div className="flex gap-2 items-start">
          <Skeleton className="w-20 h-4" />
          <Skeleton className="w-16 h-4" />
        </div>
        <Skeleton className="h-5 w-24 mt-2" />
      </div>
      <div className="flex gap-2 items-end">
        <Skeleton className="h-10 w-24 rounded-md" />
        <Skeleton className="h-10 w-28 rounded-md" />
      </div>
    </article>
  );
};
